import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Presentational confirm/delete card meant to be dropped inside a MatDialog or
 * bottom-sheet component. It owns no dialog refs or API calls, so the host
 * keeps its own close-result contract:
 *
 * <app-confirm-card title="Delete Author?" message="This cannot be undone."
 *   confirmLabel="Delete" [loading]="isLoading"
 *   (confirm)="deleteAuthor()" (cancel)="closeBtn()"></app-confirm-card>
 */
@Component({
  selector: 'app-confirm-card',
  templateUrl: './confirm-card.component.html',
  styleUrls: ['./confirm-card.component.scss'],
})
export class ConfirmCardComponent {
  @Input() title = 'Are you sure?';
  @Input() message = '';
  @Input() confirmLabel = 'Delete';
  @Input() loadingLabel = 'Deleting...';
  @Input() cancelLabel = 'Cancel';
  @Input() tone: 'danger' | 'primary' = 'danger';
  @Input() icon: 'trash' | 'exit' = 'trash';
  @Input() loading = false;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
